import randomString from '../modules/randomString';
import reCaptchaProtect from '../re-captcha';
import ElementValidator from './ElementValidator';

export default class {
    constructor(options) {
        this.uuid = 'f' + randomString(10);
        this.formElement = false;
        this.formElementOriginal = false;
        this.addClientId = true;
        this.addReferrer = true;
        this.niceFormName = '';
        this.hasOverlayingLabels = null;
        this.reskin = false;
        this.redesign = false;
        this.vueForm = false;
        this.elements = [];
        this.focusedElement = false;
        this.classes = {
            error: 'bg-danger',
            warning: 'bg-warning',
            info: 'bg-info',
            animationIn: 'slideInDown',
            animationOut: 'slideOutUp',
            valid: 'inputValid',
            invalid: 'inputError',
            newInvalid: 'new_inputError'
        };
        this.custom = {};
        this.loadingHtml = '<div class="loading"><img src="/images/shared/Robins-And-Day-Loader.svg" alt="Loading" /></div>';
        this.loadingClass = '.loading';
        this.loadingTarget = false;
        this.loadingInterval = false;
        this.loadingDuration = false;
        this.loadingIntervalCallback = false;
        if (typeof options == 'undefined') {
            return;
        }

        if (typeof options.addClientId !== 'undefined' && options.addClientId == false) {
            this.addClientId = false;
        }

        if (typeof options.addReferrer !== 'undefined' && options.addReferrer == false) {
            this.addReferrer = false;
        }

        if (typeof options.vueForm !== 'undefined') {
            this.setVueForm(options.vueForm);
        }

        if (typeof options.loadingHtml !== 'undefined') {
            this.loadingHtml = options.loadingHtml;
        }
        if (typeof options.loadingIntervalCallback !== 'undefined') {
            this.loadingIntervalCallback = options.loadingIntervalCallback;
        }
        if (typeof options.loadingTarget !== 'undefined') {
            this.loadingTarget = options.loadingTarget;
        }
        if (typeof options.reskin !== 'undefined') {
            this.reskin = options.reskin;
        }
        if (typeof options.hasOverlayingLabels !== 'undefined') {
            this.hasOverlayingLabels = options.hasOverlayingLabels ? true : false;
        }
        if (typeof options.redesign !== 'undefined') {
            this.redesign = options.redesign;
            this.loadingHtml = '<div class="loading-icon__container"><img src="/images/shared/Robins-And-Day-Loader-Purple.svg" alt="Loading" /></div>';
            this.loadingClass = '.loading-icon__container';
        }
        if (typeof options.classes !== 'undefined') {
            if (typeof options.classes.error !== 'undefined') {
                this.classes.error = options.classes.error;
            }
            if (typeof options.classes.valid !== 'undefined') {
                this.classes.valid = options.classes.valid;
            }
            if (typeof options.classes.invalid !== 'undefined') {
                this.classes.invalid = options.classes.invalid;
            }
        }

        // Passing in custom validation rules
        if (typeof options.custom !== 'undefined') {
            Object.keys(options.custom).forEach(key => {
                this.custom[key] = options.custom[key];
            });
        }

        if (typeof options.target !== 'undefined' && document.querySelector(options.target)) {
            this.validateSelector(options.target);
        }

        if (typeof options.element !== 'undefined') {
            this.attachToElement(options.element);
        }
    }

    addCustomValidationRule(ruleName, rule) {
        this.custom[ruleName] = rule;
    }

    setReferrer() {
        let el = this.getForm();
        if (!el) {
            return false;
        }
        if (!this.addReferrer) {
            return false;
        }
        if (!document.referrer) {
            return false;
        }
        const referrerElement = el.find("input[name='referrer']");
        if ($(referrerElement).length == 0) {
            el.prepend('<input type="hidden" name="referrer" value="' + document.referrer + '" />');
        }
        $(referrerElement).val(document.referrer);
    }

    async setRecaptchaToken() {
        let el = this.getForm();
        if (!el) {
            return false;
        }

        return await new Promise(resolve => reCaptchaProtect(() => resolve(), el));
    }

    setAddClientId(status) {
        if (status === true) {
            this.addClientId = true;
            return;
        }
        this.addClientId = false;
        return;
    }

    appendClientId() {
        if (this.addClientId === false) {
            return;
        }
        let globalGaElement = document.querySelector('#ga-client-id');
        if (!globalGaElement) {
            return;
        }

        let existingGaElementInThisForm = this.getForm()[0].querySelector("input[name='client-id']");
        if (!existingGaElementInThisForm) {
            const newGaElement = document.createElement('input');
            newGaElement.setAttribute('type', 'hidden');
            newGaElement.setAttribute('name', 'client-id');
            newGaElement.value = globalGaElement.value;
            this.getForm()[0].append(newGaElement);
            return;
        }

        existingGaElementInThisForm.value = globalGaElement.value;
    }

    // Toggles visibility of elements
    attachToggleInputEvents() {
        const currentForm = this.getForm();
        const self = this;
        currentForm.find("[data-toggle-input]").each(function (index) {
            if ($(this).is(':checkbox')) {
                self.attachValidationEventsForElement(this);
                $(this).on('change.ContactFormValidator', function () {
                    if (this.checked) {
                        $('#' + $(this).data('toggleInput')).fadeIn(150);
                    }
                    else {
                        $('#' + $(this).data('toggleInput')).fadeOut(150);
                    }
                });
                return;
            }
            if ($(this).is(':radio')) {
                self.attachValidationEventsForElement(this);
                $(currentForm + " input[name='" + $(this).attr('name') + "']").on('change.ContactFormValidator', function () {
                    $(currentForm + " input[name='" + $(this).attr('name') + "']").each(function () {
                        if ($('#' + $(this).attr('data-toggle-input'))) {
                            if (this.checked) {
                                $('#' + $(this).data('toggleInput')).fadeIn(150);
                            }
                            else {
                                $('#' + $(this).data('toggleInput')).fadeOut(150);
                            }
                        }
                    });
                });
            }
        });
    }

    setForm(element) {
        if (element instanceof jQuery) {
            this.formElement = element;
            this.formElementOriginal = element[0];
            return;
        }
        this.formElement = $(element);
        this.formElementOriginal = element;
    }

    getForm() {
        return this.formElement;
    }

    validate(formToValidate) {
        this.validateSelector('#' + formToValidate);
    }

    attachToElement(formElement) {
        if (typeof formElement !== 'undefined') {
            this.setForm(formElement);
            this.setup();
            return true;
        }
        console.error('form element is undefined', formElement);
    }

    validateSelector(formToValidate) {
        let el = $(formToValidate);
        if (el) {
            this.setForm(el);
            this.setup();
            return true;
        }
        console.error('form does not exist', formToValidate);
    }

    setVueForm(vueForm = false) {
        this.vueForm = (vueForm === true) ? true : false;
    }

    unbind() {
        // Step through all current elements and unbind them
        this.elements.forEach(element => {
            element.unbindEvents();
        });
        this.elements = [];
    }

    updateValidatableElements() {
        // Step through all current elements and unbind them
        this.elements.forEach(element => {
            element.unbindEvents();
        });
        // Blank the current elements
        this.elements = [];
        const itemsToValidate = this.getForm()[0].querySelectorAll("[data-validate]");
        const itemsLength = itemsToValidate.length;
        let currentElement;
        for (let index = 0; index < itemsLength; index++) {
            currentElement = new ElementValidator({
                element: itemsToValidate[index],
                form: this,
            });
            currentElement.bindEvents();
            currentElement.bindTagManagerEvents();
            this.elements.push(currentElement);
        }
    }

    setup() {
        if (!this.getForm()) {
            return false;
        }
        this.setNiceFormName();
        this.setupFormsWithOverlayingLabels();
        this.updateValidatableElements();

        if (typeof window.preloadedUser != 'undefined') {
            this.formElementOriginal.querySelectorAll('input, select, textarea').forEach(element => {
                if (element.value != '') {
                    return;
                }
                const elementName = element.getAttribute('name');
                if (elementName == 'title' && typeof window.preloadedUser.title != 'undefined') {
                    element.value = window.preloadedUser.title;
                    const event = new Event('change', { bubbles: true });
                    element.dispatchEvent(event);
                }
                if ((elementName == 'first-name' || elementName == 'first_name') && typeof window.preloadedUser.first_name != 'undefined') {
                    element.value = window.preloadedUser.first_name;
                    const event = new Event('change', { bubbles: true });
                    element.dispatchEvent(event);
                }
                if ((elementName == 'last-name' || elementName == 'last_name') && typeof window.preloadedUser.last_name != 'undefined') {
                    element.value = window.preloadedUser.last_name;
                    const event = new Event('change', { bubbles: true });
                    element.dispatchEvent(event);
                }
                if (elementName == 'email' && typeof window.preloadedUser.email != 'undefined') {
                    element.value = window.preloadedUser.email;
                    const event = new Event('change', { bubbles: true });
                    element.dispatchEvent(event);
                }
                if ((elementName == 'telephone' || elementName == 'tel' || elementName == 'phone') && typeof window.preloadedUser.tel != 'undefined') {
                    element.value = window.preloadedUser.tel;
                    const event = new Event('change', { bubbles: true });
                    element.dispatchEvent(event);
                }
            });
        }
        // If it's a material form, we need to add the active class to any element that's not empty
        if (this.hasOverlayingLabels) {
            this.getForm().find("input").not('[type="checkbox"]').not('[type="radio"]').on('change.validator', function (index) {
                if (!$(this).val()) {
                    $(this).removeClass('active');
                    return;
                }
                $(this).addClass('active');
            });
            this.getForm().find("input").not('[type="checkbox"]').not('[type="radio"]').each(function (index) {
                if (!$(this).val()) {
                    $(this).removeClass('active');
                    return;
                }
                $(this).addClass('active');
            });
            this.getForm().find("select, textarea").on('change.validator', function (index) {
                if (!$(this).val()) {
                    $(this).removeClass('active');
                    return;
                }
                $(this).addClass('active');
            });
            this.getForm().find("select, textarea").each(function (index) {
                if (!$(this).val()) {
                    $(this).removeClass('active');
                    return;
                }
                $(this).addClass('active');
            });
        }

        this.attachToggleInputEvents();
        this.setReferrer();
    }



    setNiceFormName() {
        let el = this.getForm();
        if (el && el.length > 0 && typeof el.data('formName') !== 'undefined') {
            this.niceFormName = el.data('formName');
            return true;
        }
        this.niceFormName = '#' + el.attr('id');
    }

    setupFormsWithOverlayingLabels() {
        this.formElementOriginal.querySelectorAll('input, select, textarea').forEach(element => {
            if (element.type == 'hidden') {
                return;
            }
            if (element.type == 'checkbox') {
                return;
            }
            if (element.type == 'radio') {
                return;
            }
            if (element.type == 'file') {
                return;
            }

            const thisElementsLabel = this.formElementOriginal.querySelector('label[for="' + element.getAttribute('id') + '"]');
            if (!thisElementsLabel) {
                return;
            }
            if (thisElementsLabel.getAttribute('always-active') !== null) {
                thisElementsLabel.classList.add('form-element__label--active');
                return;
            }
            if (!thisElementsLabel.classList.contains('form-element__label')) {
                return;
            }

            this.handleElementLabelPosition(element, thisElementsLabel);

            // Setup a MutationObserver to watch for changes to the <option> structure inside a <select> element and handle the label state accordingly based on there being a placeholder value or not
            if (element.type === 'select-one' || element.type === 'select-multiple') {
                const observer = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        if (mutation.type === 'childList') {
                            this.handleElementLabelPosition(element, thisElementsLabel);
                        }
                    });
                });

                observer.observe(element, {
                    childList: true,
                    subtree: true
                });
            }

            thisElementsLabel.addEventListener('click', function(event) {
                thisElementsLabel.classList.add('form-element__label--active');
                if (element.dataset.customerLocation) {
                    // There are 2 elements here, the visible autocomplete input, and the hidden input that holds the actual value
                    // Search for the visible autocomplete input by looking for a sibling element with style display not none
                    const parent = element.parentElement;
                    const visibleInput = parent.querySelector('input[data-customer-location="true"]:not([style*="display: none"])');
                    if (visibleInput) {
                        visibleInput.focus();
                        // Trigger focus event since the above doesn't
                        const focusEvent = new Event('focus', { bubbles: true });
                        visibleInput.dispatchEvent(focusEvent);
                        return;
                    }
                    element.focus();
                }
            });
            element.addEventListener('change', () => {
                console.log('change event for label position');
                this.handleElementLabelPosition(element, thisElementsLabel);
            });
            element.addEventListener('blur', () => {
                this.handleElementLabelPosition(element, thisElementsLabel);
            });
            element.addEventListener('focus', function(event) {
                thisElementsLabel.classList.add('form-element__label--active');
            });
        });


        // If we've already set the form as material form in the constructor then use that value
        if (this.hasOverlayingLabels != null) {
            return;
        }
        if (this.formElementOriginal && this.formElementOriginal.classList.contains('material-form')) {
            this.hasOverlayingLabels = true;
            return true;
        }
        this.hasOverlayingLabels = false;
        return false;
    }

    handleElementLabelPosition(element, thisElementsLabel) {
        if (element.value !== '') {
            thisElementsLabel.classList.add('form-element__label--active');
            return;
        }

        if (element.type == 'select-one' || element.type == 'select-multiple') {
            // Check if the select element initial selected option is a placeholder option (non empty inner text), and if so, mark the label as active
            if (element.options && element.options.length > 0) {
                const selectedOption = element.options[element.selectedIndex];
                if (selectedOption && selectedOption.textContent.trim() !== '') {
                    thisElementsLabel.classList.add('form-element__label--active');
                    return;
                }
            }
        }

        thisElementsLabel.classList.remove('form-element__label--active');
    }

    checkValidateIfTarget(element) {
        if ($(element).attr('data-validate-if-type')) {
            //Check target element exists
            if ($('#' + $(element).data('validateIf')).length > 0) {
                if ($(element).data('validateIfType') == 'checkbox' || $(element).data('validateIfType') == 'radio') {
                    if ($('#' + $(element).data('validateIf')).is(':checked')) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    /**
     * Are all elements valid?
     * @param {function} filter  Filter
     * @param {bool} skipRecaptcha  Skip recaptcha validation
     * @returns {bool}
     */
    async isValid(filter = null, skipRecaptcha = false) {
        let isValid = true;

        await this.elements.forEach(async (element) => {
            if (filter && filter(element) === false) {
                return;
            }
            if (!await element.isValid()) {
                isValid = false;
            }
        });

        if (!isValid) {
            return false;
        }

        this.appendClientId();

        if (skipRecaptcha !== true) {
            await this.setRecaptchaToken();
        }

        return isValid;
    }

    async validateAndSubmit(filter = null, skipRecaptcha = false, submissionPromise) {
        return new Promise(async (resolve, reject) => {
            // If FormData is collected after this.preventInput() is called, then all the disabled inputs will not be included in the FormData.
            // So we need to collect FormData before calling this.preventInput().
            const formData = new FormData(this.formElementOriginal);
            this.preventInput();

            if (await this.isValid(filter, skipRecaptcha) === false) {
                this.scrollToFirstError();
                this.allowInput();
                reject();
                return;
            }

            // Since the recaptcha response is added after the FormData is created, we need to append it here.
            if (this.formElementOriginal.querySelector('input[name="g-recaptcha-response"]')) {
                formData.append('g-recaptcha-response', this.formElementOriginal.querySelector('input[name="g-recaptcha-response"]').value);
            }

            submissionPromise(formData)
                .then(() => {
                    resolve();
                    this.successResponse();
                })
                .catch((response) => {
                    reject(response);
                    this.errorResponse(response);
                });
        });
    }

    scrollToFirstError() {
        // Iterate over the errors and find which one is closest to the top of the page
        // Then scroll to that point, minus the height of the header bar
        let firstErrorElement = null;
        const errorInputElements = this.formElementOriginal.querySelectorAll('.inputError, .validation-error');
        errorInputElements.forEach(element => {
            if (firstErrorElement == null) {
                firstErrorElement = element;
                return;
            }
            if (element.getBoundingClientRect().top < firstErrorElement.getBoundingClientRect().top) {
                firstErrorElement = element;
            }
        });
        if (firstErrorElement == null) {
            return;
        }
        const header = document.querySelector('header');
        let headerOffset = 0;
        if (header) {
            headerOffset = header.offsetHeight;
        }
        const elementPosition = firstErrorElement.getBoundingClientRect().top + window.pageYOffset;
        let offsetPosition = elementPosition - headerOffset - 60;
        if (offsetPosition < 0) {
            offsetPosition = 0;
        }

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }

    getInvalidElements() {
        const invalidElements = [];
        this.elements.forEach(async element => {
            if (!await element.isValid()) {
                invalidElements.push(element);
            }
        });
        return invalidElements;
    }

    /**
     * Starts a looping interval that calls loadingIntervalCallback(duration) every 1s, with the duration the loading screen has been active as the duration passed in
     */
    startLoadingInterval() {
        this.endLoadingInterval();
        if (this.loadingIntervalCallback == false) {
            return false;
        }
        window.setInterval(() => {
            this.loadingIntervalCallback(this.loadingDuration);
            this.loadingDuration++;
        }, 1000);
        return true;
    }

    /**
     * Clears any existing loading interval
     */
    endLoadingInterval() {
        this.loadingDuration = 0;
        if (this.loadingInterval == false) {
            return true;
        }
        clearInterval(this.loadingInterval);
        return true;
    }

    /**
     * Blocks all form inputs and renders this.loadingHtml over the top of the form
     * By default this is the 3 animated R&D loading dots
     * The HTML can be changed using {loadingHtml: ''} in the constructor
     */
    preventInput() {
        $(this.getForm()).find(this.loadingClass).remove();
        $(this.getForm()).find(":input").addClass('disabled').prop('disabled', true);
        // If we have a loadingTarget element, use it instead of the default form
        if (this.loadingTarget == false) {
            $(this.getForm()).append(this.loadingHtml).fadeIn(0);
        } else {
            $(this.loadingTarget).append(this.loadingHtml).fadeIn(0);
        }
        this.startLoadingInterval();
    }

    /**
     * Allows input again
     */
    allowInput() {
        $(this.getForm()).find(":input").removeClass('disabled').prop('disabled', false);
        // If we have a loadingTarget element, use it instead of the default form
        if (this.loadingTarget == false) {
            console.log('Removing loading class from form', this.getForm());
            $(this.getForm()).find(this.loadingClass).remove();
        } else {
            console.log('Removing loading class from loadingTarget', this.loadingTarget);
            $(this.loadingTarget).find(this.loadingClass).remove();
        }
        this.endLoadingInterval();
    }

    parseErrorResponse(response) {
        if (typeof response.response !== 'undefined') {
            response = response.response;
        }
        if (typeof response.status !== 'undefined') {
            if (response.status == 500) {
                return { "form": ["Sorry, an unknown error has occurred, please check your details and try again"] };
            }
            if (response.status == 429) {
                if (typeof response.responseText !== 'undefined' && response.responseText == 'Valuation limit reached.') {
                    return { "form": ["Sorry, you may only submit up to 3 valuations per 24 hours."] };
                }
                if (typeof response.data !== 'undefined' && response.data == 'Valuation limit reached.') {
                    return { "form": ["Sorry, you may only submit up to 3 valuations per 24 hours."] };
                }
                return { "form": ["Sorry, our server has too many requests coming in at the moment."] };
            }
            if (response.status == 403) {
                if (typeof response.data.responseText !== 'undefined') {
                    return { "form": [response.data.responseText] };
                }
            }
        }
        if (typeof response.responseText !== 'undefined') {
            return jQuery.parseJSON(response.responseText);
        }
        if (typeof response.data !== 'undefined') {
            return response.data;
        }
        if (typeof response.errors !== 'undefined') {
            return response.errors;
        }

        return { "form": ["Sorry, an unknown error has occurred, please check your details and try again"] };
    }

    recursivelyGetErrorsFromObject(data, output) {
        if (typeof data == 'undefined') {
            return false;
        }
        // We only wan't to add strings to the error messages
        if (typeof data == 'string' && data != '') {
            return `<li>${data}</li>`;
        }
        if (typeof data == 'object') {
            $.each(data, function (index, subData) {
                // To ensure we don't end up with the false value from 'undefined' in the response, we'll conditionally add the error message if it's not false here
                let possibleValue = this.recursivelyGetErrorsFromObject(subData, output);
                if (possibleValue !== false) {
                    output.push(possibleValue);
                }
            }.bind(this));
        }
        return output;
    }

    errorResponse(response) {
        this.formElement.find('.validation-error').remove();
        this.allowInput();

        if (typeof response == 'undefined') {
            return false;
        }
        let data = this.parseErrorResponse(response);
        let e = this.recursivelyGetErrorsFromObject(data, []);

        if (typeof e !== 'object' || e.length == 0) {
            e.push('<li class="validation-error__li">An unknown error has occurred, please try refreshing the page</li>');
        }

        this.formElement.prepend(`<div class="bg-danger validation-error animated slideInDown"><ul class="validation-error__ul">${e.join('')}</ul></div>`);

        this.formElement.find('.validation-error').first()[0].scrollIntoView();
    }

    successResponse() {
        this.formElement.find('.validation-error').remove();
        this.allowInput();
    }
}